import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { AssistantMessage } from '../types';
import { useAssistant } from '../AssistantProvider';
import { WarnIcon } from '../icons';

/*
 * Failed-turn card. Shows the error detail and an outlined Retry button that
 * re-runs the turn (re-posts the preceding user message).
 */
const FailCard = ({ message }: { message: AssistantMessage }) => {
  const { t } = useTranslation('assistant');
  const { retryTurn } = useAssistant();
  const [retried, setRetried] = useState(false);
  return (
    <div className="bra-fail">
      <div className="bra-ft">
        <WarnIcon width={15} height={15} />
        {t('This turn failed')}
      </div>
      <div className="bra-fb">
        {message.error_detail ||
          t(
            'The assistant run was interrupted before completing. Your message was saved — you can retry this turn.'
          )}
      </div>
      <button
        type="button"
        className="bra-btn bra-retry"
        disabled={retried}
        onClick={() => {
          setRetried(true);
          retryTurn(message);
        }}
      >
        {t('Retry')}
      </button>
    </div>
  );
};

export default FailCard;
